// extracted by mini-css-extract-plugin
module.exports = {"root":"quickbooks_root__2cSc5","infoBtn":"quickbooks_infoBtn__32K4F","formBox":"quickbooks_formBox__kJQFk","formFooter":"quickbooks_formFooter__3Hz8X"};